import { Form, FormField, isEmail, isNotEmpty } from '#shared/form';
import dayjs from 'dayjs';

export class SignInProfileFillingStepForm extends Form<{
  name: string;
  email: string;
  birthDate: string;
  notifications: boolean;
}> {
  constructor() {
    super({
      name: new FormField<string>(''),
      email: new FormField<string>(''),
      birthDate: new FormField<string>(''),
      notifications: new FormField<boolean>(false),
    });

    this.formData.name.addValidator({
      message: 'Введите имя',
      validateFn: isNotEmpty
    });

    this.formData.email.addValidator({
      message: 'Введите корректный email',
      validateFn: isEmail
    });

    this.formData.birthDate.addValidator({
      message: 'Введите корректную дату рождения',
      validateFn: (value) => {
        if (!value) return true;

        const birthDate = dayjs(value);
        return birthDate.isValid();
      }
    });

    this.formData.birthDate.addValidator({
      message: 'Регистрация доступна с 18 лет',
      validateFn: (value) => {
        if (!value) return true;

        const now = dayjs();
        const birthDate = dayjs(value);
        const age = now.diff(birthDate, 'year', true);
        return age >= 18; 
      }
    });

    this.makeSnapshot();
  }

  public override reset() {
    this.formData.name.value = '';
    this.formData.email.value = '';
    this.formData.birthDate.value = '';
    this.formData.notifications.value = false;
  }
}
